import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

declare global {
    interface Window {
        gsap: typeof gsap;
        scrollTrigger: typeof ScrollTrigger;
    }
}

window.addEventListener("load", () => {
    const numberElements = document.querySelectorAll<HTMLElement>("[data-count]");
    const elements = document.querySelectorAll<HTMLElement>("[data-progress]");
    const expertCTAs = document.querySelectorAll<HTMLElement>(".expert-cta");

    if (numberElements.length === 0 && elements.length === 0 && expertCTAs.length === 0) {
        return;
    }

    window.gsap = gsap;
    window.scrollTrigger = ScrollTrigger;

    async function initializeCount() {
        const { Count } = await import('./count');
        numberElements.forEach((number) => {
            new Count(number);
        });
    }

    async function initializeProgress() {
        const { Progress } = await import('./progress');
        elements.forEach((trigger) => {
            new Progress(trigger);
        });
    }

    async function initializeExperts() {
        const { Expert } = await import('./expert');
        expertCTAs.forEach((cta) => {
            new Expert(cta);
        });
    }

    if (numberElements.length > 0) {
        initializeCount();
    }

    if (elements.length > 0) {
        initializeProgress();
    }

    if (expertCTAs.length > 0) {
        initializeExperts();
    }
})